/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__id_number_name_string__Array_ } from '../models/ControllerResponse__id_number_name_string__Array_';
import type { ControllerResponse__items_58__40_UserAttributes_and__report_ids_number_Array__41__Array_total_number__ } from '../models/ControllerResponse__items_58__40_UserAttributes_and__report_ids_number_Array__41__Array_total_number__';
import type { ControllerResponse__tag_name_string_count_number__Array_ } from '../models/ControllerResponse__tag_name_string_count_number__Array_';
import type { ControllerResponse_AccessUser_Array_ } from '../models/ControllerResponse_AccessUser_Array_';
import type { ControllerResponse_null_ } from '../models/ControllerResponse_null_';
import type { ControllerResponse_number_Array_ } from '../models/ControllerResponse_number_Array_';
import type { ControllerResponse_number_or_null_ } from '../models/ControllerResponse_number_or_null_';
import type { ControllerResponse_OrganizationAttributes_or_null_ } from '../models/ControllerResponse_OrganizationAttributes_or_null_';
import type { ControllerResponse_ReportVisitHistoryEntry_Array_ } from '../models/ControllerResponse_ReportVisitHistoryEntry_Array_';
import type { ControllerResponse_ScheduledReport_Array_ } from '../models/ControllerResponse_ScheduledReport_Array_';
import type { ControllerResponse_string_ } from '../models/ControllerResponse_string_';
import type { Omit_OrganizationAttributes_id_ } from '../models/Omit_OrganizationAttributes_id_';
import type { UserAttributes } from '../models/UserAttributes';
import type { UserUpdatePayload } from '../models/UserUpdatePayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Resend the verification email to the current user.
     * @returns ControllerResponse_string_ Ok
     * @throws ApiError
     */
    public resendVerifyEmail(): CancelablePromise<ControllerResponse_string_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/resend_verify_email',
        });
    }
    /**
     * Update the current user's data.
     * @param requestBody The updated user data
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public updateUserData(
        requestBody: UserUpdatePayload,
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the pending organization invitation for the current user's email.
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getInvitation(): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/invitation',
        });
    }
    /**
     * Accept the pending organization invitation for the current user.
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public acceptInvitation(): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/accept_invitation',
        });
    }
    /**
     * Deny the pending organization invitation for the current user.
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public denyInvitation(): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/deny_invitation',
        });
    }
    /**
     * List organization members
     * @param page The page number to fetch (starting from 1)
     * @param limit The number of results per page
     * @param search Optional global search term to filter members
     * @param sortBy Optional column to sort by
     * @param descending Whether to sort in descending order
     * @param groupIds Optional comma-separated list of group IDs to filter by
     * @returns any Ok
     * @throws ApiError
     */
    public listOrganizationMembers(
        page: number,
        limit: number = 10,
        search?: string,
        sortBy?: string,
        descending?: boolean,
        groupIds?: string,
    ): CancelablePromise<{
        total: number;
        items: Array<UserAttributes>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization_members',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'sort_by': sortBy,
                'descending': descending,
                'group_ids': groupIds,
            },
        });
    }
    /**
     * List report accesses within the organization
     * @param page The page number to fetch (starting from 1)
     * @param limit The number of results per page
     * @param search Optional global search term to filter results
     * @param sortBy Optional column to sort by
     * @param descending Whether to sort in descending order
     * @returns ControllerResponse__items_58__40_UserAttributes_and__report_ids_number_Array__41__Array_total_number__ Ok
     * @throws ApiError
     */
    public listOrganizationReportAccesses(
        page: number,
        limit: number = 10,
        search?: string,
        sortBy?: string,
        descending?: boolean,
    ): CancelablePromise<ControllerResponse__items_58__40_UserAttributes_and__report_ids_number_Array__41__Array_total_number__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization_report_accesses',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'sort_by': sortBy,
                'descending': descending,
            },
        });
    }
    /**
     * Search for people within the organization or shared with the organization.
     * @param q The search query string
     * @param limit The maximum number of results to return
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public searchPeople(
        q?: string,
        limit: number = 10,
    ): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/search_people',
            query: {
                'q': q,
                'limit': limit,
            },
        });
    }
    /**
     * Search for groups within the organization.
     * @param q The search query string
     * @param limit The maximum number of results to return
     * @returns ControllerResponse__id_number_name_string__Array_ Ok
     * @throws ApiError
     */
    public searchGroups(
        q?: string,
        limit: number = 10,
    ): CancelablePromise<ControllerResponse__id_number_name_string__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/search_groups',
            query: {
                'q': q,
                'limit': limit,
            },
        });
    }
    /**
     * Get all report IDs the specified user has access to within the org.
     * @param userId The ID of the user to get report IDs for
     * @returns ControllerResponse_number_Array_ Ok
     * @throws ApiError
     */
    public reportIdsByUser(
        userId: string,
    ): CancelablePromise<ControllerResponse_number_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/report_ids_by_user',
            query: {
                'user_id': userId,
            },
        });
    }
    /**
     * Remove a user from the organization and optionally transfer their data to another user.
     * @param requestBody The user ID to remove and optional transfer user ID
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public removeFromOrganization(
        requestBody: {
            transfer_user_id?: string;
            user_id: string;
        },
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/remove_from_organization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the organization details for the current user.
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getOrganization(): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization',
        });
    }
    /**
     * Update organization details.
     * @param id The ID of the organization to update
     * @param requestBody The updated organization attributes
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public patchOrganization(
        id: number,
        requestBody: Omit_OrganizationAttributes_id_,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/organization',
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get report tags with their counts for the current user's organization.
     * @returns ControllerResponse__tag_name_string_count_number__Array_ Ok
     * @throws ApiError
     */
    public getOrganizationTagsWithCount(): CancelablePromise<ControllerResponse__tag_name_string_count_number__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization/tags',
        });
    }
    /**
     * Invite people to the organization via email.
     * @param requestBody A list of email addresses to invite
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public invitePeople(
        requestBody: {
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/invite_people',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Preview a seat update invoice for the organization.
     * @param seats The new total number of seats
     * @returns any Ok
     * @throws ApiError
     */
    public seatUpdateInvoice(
        seats: number,
    ): CancelablePromise<{
        data: {
            amount_due: number;
            total: number;
            discount: {
                name?: string | null;
                amount: number;
            } | null;
            subtotal: number;
        } | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/seat_update_invoice',
            query: {
                'seats': seats,
            },
        });
    }
    /**
     * Resend the organization invitation email to a specific address.
     * @param email The email address to resend the invitation to
     * @returns ControllerResponse_number_or_null_ Ok
     * @throws ApiError
     */
    public resendInviteEmail(
        email: string,
    ): CancelablePromise<ControllerResponse_number_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/resend_invite_email',
            query: {
                'email': email,
            },
        });
    }
    /**
     * Get a list of recent people within the organization or shared with it.
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public getPeopleInOrgOrShared(): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/recent_people',
        });
    }
    /**
     * Get all scheduled report subscriptions for the current user.
     * @returns ControllerResponse_ReportVisitHistoryEntry_Array_ Ok
     * @throws ApiError
     */
    public getReportHistory(): CancelablePromise<ControllerResponse_ReportVisitHistoryEntry_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/report_history',
        });
    }
    /**
     * @returns ControllerResponse_ScheduledReport_Array_ Ok
     * @throws ApiError
     */
    public getSchedules(): CancelablePromise<ControllerResponse_ScheduledReport_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/schedules',
        });
    }
    /**
     * Unsubscribe from a scheduled report.
     * @param id The ID of the scheduled report to unsubscribe from
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public unsubscribeFromSchedule(
        id: number,
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/user/schedules/{id}',
            path: {
                'id': id,
            },
        });
    }
}
